// Mock data for AI Video Creator Portfolio

export const portfolioData = {
  hero: {
    name: "Adil",
    subtitle: "AI Video Creator",
    tagline: "Level 2 Fiverr Seller | 4+ Years Experience",
    stats: "5.0 Rating · 192 Reviews · $15/hour",
    description: "Creating viral-ready AI videos using Google Veo 3 for Instagram Reels, TikTok, YouTube Shorts, and faceless content that performs",
    cta: "View My Work",
    secondaryCta: "Order on Fiverr",
    profileImage: "/profile-photo.jpg"
  },
  
  services: [
    {
      id: 1,
      title: "AI Health & Supplement Videos",
      description: "Create engaging AI-powered reels and videos that highlight your health supplements, explain benefits, and motivate viewers to take action. Perfect for TikTok, Instagram, and YouTube.",
      icon: "Heart",
      rating: "5.0",
      reviews: "71+ reviews",
      features: ["Product benefit highlights", "Boost credibility & sales", "TikTok, Instagram, YouTube"]
    },
    {
      id: 2,
      title: "AI ASMR Videos",
      description: "Hyper-realistic, visually satisfying videos like glass fruit cutting or relaxing visuals, optionally enhanced with ASMR sounds to captivate and soothe your audience. Ideal for TikTok, Reels, and faceless content.",
      icon: "Sparkles",
      rating: "5.0",
      reviews: "45+ reviews",
      features: ["Hyper-realistic visuals", "Optional ASMR audio", "Fully customizable"]
    },
    {
      id: 3,
      title: "Viral AI Baby Videos",
      description: "Adorable AI-generated baby avatars, podcasts, skits, or lookalike videos designed to go viral. Includes scriptwriting, voiceovers, and editing for ready-to-post content.",
      icon: "Baby",
      rating: "5.0",
      reviews: "Multiple orders",
      features: ["AI baby avatars", "Script & voiceovers included", "Ready-to-post content"]
    },
    {
      id: 4,
      title: "AI Objects Talking Videos",
      description: "Bring products, ingredients, or services to life with talking AI objects that explain benefits in a fun, engaging, and educational way. Perfect for brands, e-commerce, and social media ads.",
      icon: "MessageSquare",
      rating: "5.0",
      reviews: "6+ reviews",
      features: ["Products that speak", "Engaging & humorous", "Drive awareness & sales"]
    },
    {
      id: 5,
      title: "AI Horror Story Reels",
      description: "Spine-chilling AI-generated horror reels with gripping scripts, eerie voiceovers, and suspenseful visuals. Optimized for TikTok, Instagram, and YouTube to increase watch time and engagement.",
      icon: "Ghost",
      rating: "5.0",
      reviews: "New service",
      features: ["Gripping horror scripts", "Professional voiceovers", "Boost watch time"]
    },
    {
      id: 6,
      title: "AI Skeleton Videos",
      description: "Eye-catching AI skeleton animations for Halloween, fitness, dance, or educational content. Fully customizable actions, styles, and backgrounds for viral and shareable videos.",
      icon: "Skull",
      rating: "5.0",
      reviews: "Trending now",
      features: ["Skeleton animations", "Dance & comedy skits", "Viral-ready content"]
    },
    {
      id: 7,
      title: "Motivational AI Character Videos",
      description: "Animated AI characters delivering motivational quotes, life lessons, or inspiring messages. Includes attention-grabbing hooks, professional editing, and platform-optimized formats.",
      icon: "Zap",
      rating: "5.0",
      reviews: "Growing demand",
      features: ["Motivational quotes", "Life lessons & ideas", "Inspire your audience"]
    },
    {
      id: 8,
      title: "Realistic AI UGC & Ad Videos",
      description: "Faceless, high-converting AI-generated UGC content for TikTok Shop, Meta Ads, and Instagram. Complete post-production included: scripts, voiceovers, subtitles, and final export.",
      icon: "Video",
      rating: "5.0",
      reviews: "High conversion",
      features: ["TikTok Shop & Meta Ads", "High-converting visuals", "Scripts & subtitles included"]
    }
  ],
  
  portfolio: [
    {
      id: 1,
      title: "AI Health & Supplement Videos",
      category: "AI Health & Supplement Videos",
      thumbnail: "https://images.pexels.com/photos/3768722/pexels-photo-3768722.jpeg",
      duration: "0:30",
      description: "Create engaging AI-powered reels and videos that highlight your health supplements, explain benefits, and motivate viewers to take action. Perfect for TikTok, Instagram, and YouTube.",
      videoUrl: "/health-nature-video.mp4"
    },
    {
      id: 2,
      title: "AI ASMR Videos",
      category: "AI ASMR Videos",
      thumbnail: "https://images.pexels.com/photos/2047905/pexels-photo-2047905.jpeg",
      duration: "0:45",
      description: "Hyper-realistic, visually satisfying videos like glass fruit cutting or relaxing visuals, optionally enhanced with ASMR sounds to captivate and soothe your audience. Ideal for TikTok, Reels, and faceless content.",
      videoUrl: "/asmr-video.mp4"
    },
    {
      id: 3,
      title: "Viral AI Baby Videos",
      category: "Viral AI Baby Videos",
      thumbnail: "https://images.pexels.com/photos/6802994/pexels-photo-6802994.jpeg",
      duration: "1:00",
      description: "Adorable AI-generated baby avatars, podcasts, skits, or lookalike videos designed to go viral. Includes scriptwriting, voiceovers, and editing for ready-to-post content.",
      videoUrl: "/baby-video.mp4"
    },
    {
      id: 4,
      title: "AI Objects Talking Videos",
      category: "AI Objects Talking Videos",
      thumbnail: "https://images.pexels.com/photos/2335046/pexels-photo-2335046.jpeg",
      duration: "0:40",
      description: "Bring products, ingredients, or services to life with talking AI objects that explain benefits in a fun, engaging, and educational way. Perfect for brands, e-commerce, and social media ads.",
      videoUrl: "/talking-objects-video.mp4"
    },
    {
      id: 5,
      title: "AI Horror Story Reels",
      category: "AI Horror Story Reels",
      thumbnail: "https://images.unsplash.com/photo-1552233707-a3185320d9a0",
      duration: "0:50",
      description: "Spine-chilling AI-generated horror reels with gripping scripts, eerie voiceovers, and suspenseful visuals. Optimized for TikTok, Instagram, and YouTube to increase watch time and engagement.",
      videoUrl: "/skeleton-video.mp4"
    },
    {
      id: 6,
      title: "AI Skeleton Videos",
      category: "AI Skeleton Videos",
      thumbnail: "https://images.pexels.com/photos/205316/pexels-photo-205316.png",
      duration: "0:35",
      description: "Eye-catching AI skeleton animations for Halloween, fitness, dance, or educational content. Fully customizable actions, styles, and backgrounds for viral and shareable videos.",
      videoUrl: "/skeleton-lions-video.mp4"
    },
    {
      id: 7,
      title: "Motivational AI Character Videos",
      category: "Motivational AI Character Videos",
      thumbnail: "https://images.pexels.com/photos/3768722/pexels-photo-3768722.jpeg",
      duration: "0:45",
      description: "Animated AI characters delivering motivational quotes, life lessons, or inspiring messages. Includes attention-grabbing hooks, professional editing, and platform-optimized formats.",
      videoUrl: "/motivational-video.mp4"
    },
    {
      id: 8,
      title: "Realistic AI UGC & Ad Videos",
      category: "Realistic AI UGC & Ad Videos",
      thumbnail: "https://images.pexels.com/photos/2047905/pexels-photo-2047905.jpeg",
      duration: "0:30",
      description: "Faceless, high-converting AI-generated UGC content for TikTok Shop, Meta Ads, and Instagram. Complete post-production included: scripts, voiceovers, subtitles, and final export.",
      videoUrl: "/ugc-video.mp4"
    }
  ],
  
  process: [
    {
      step: 1,
      title: "Share Your Vision",
      description: "Tell me about your content goals, target audience, and video style. I respond within 1 hour!"
    },
    {
      step: 2,
      title: "AI Production with Google Veo 3",
      description: "I create your video using cutting-edge Google Veo 3 AI technology for stunning, viral-ready results"
    },
    {
      step: 3,
      title: "Review & Revisions",
      description: "Watch your video and request any changes. I ensure you're 100% satisfied with the final result"
    },
    {
      step: 4,
      title: "Fast Delivery",
      description: "Receive your high-quality video ready to upload and grow your audience on Instagram, TikTok, or YouTube"
    }
  ],
  
  testimonials: [
    {
      id: 1,
      name: "faith_in_law",
      role: "Video Producer",
      company: "United States",
      content: "I am so pleased to see such great work... I am doing over 100 of these videos. I am going to be one of his best clients.",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 2,
      name: "tia_mindful",
      role: "Content Creator",
      company: "United States",
      content: "Adil was quick to respond, executed the brief perfectly, and delivered the content in only a few hours... I highly recommend Adil! Thank you!",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 3,
      name: "sergioacosta364",
      role: "Content Creator",
      company: "United States",
      content: "Excellent! Best video editor!",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 4,
      name: "jayhu1164",
      role: "Creator",
      company: "United States",
      content: "Great work!",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 5,
      name: "niicash",
      role: "Content Creator",
      company: "Netherlands",
      content: "great video delivered. he understand what I want.",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 6,
      name: "victoriarahming",
      role: "Creator",
      company: "United States",
      content: "This Creator did an amazing job. I am looking forward to working with him on many more projects.",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 7,
      name: "jennyfinn17",
      role: "Content Creator",
      company: "United Kingdom",
      content: "Great videos",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 8,
      name: "cassandrabell91",
      role: "Content Producer",
      company: "United States",
      content: "Excellent, this artist is amazing.",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 9,
      name: "annatepl",
      role: "Content Creator",
      company: "United Kingdom",
      content: "Amazing delivery thank you",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 10,
      name: "cblair109",
      role: "Content Manager",
      company: "United States",
      content: "This is my fourth job with this guy, and every time he overdelivers... Definitely hire this guy",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 11,
      name: "moziie",
      role: "Business Owner",
      company: "United States",
      content: "Great experience working with this freelancer, delivered quickly, accurately and went above and beyond. Will definitely be returning",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 12,
      name: "robertoborrero",
      role: "Creator",
      company: "United States",
      content: "first time using and highly recommended. will definitely be using again.",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 13,
      name: "karlcamilo",
      role: "Content Creator",
      company: "United States",
      content: "Thanks for your quality and quick job",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 14,
      name: "carltonfletcher",
      role: "Creator",
      company: "Canada",
      content: "Awesome job! Looking forward to rebooking with you",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 15,
      name: "netzah66",
      role: "Content Creator",
      company: "Israel",
      content: "Thank you very much for your great work, it was a pleasure to work with you... You put attention to the little details",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 16,
      name: "dwalsh1",
      role: "Creator",
      company: "United States",
      content: "Thanks a million excellent work",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 17,
      name: "kirstenkwon",
      role: "Content Creator",
      company: "United States",
      content: "Great to work with. Would use Adil's service again.",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 18,
      name: "rahulpillai770",
      role: "Creator",
      company: "India",
      content: "Excellent work. The video are really nice. Highly recommended",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 19,
      name: "lyen_h",
      role: "Content Creator",
      company: "Netherlands",
      content: "He did a great job! And I'm happy with it!",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 20,
      name: "dekathus",
      role: "Creator",
      company: "United States",
      content: "as described, great work",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 21,
      name: "marco_hofer",
      role: "Business Owner",
      company: "Switzerland",
      content: "perfect work!!!!!! my 4th order and not the last, thank you for everything",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 22,
      name: "ameracell",
      role: "Content Creator",
      company: "United States",
      content: "Great job this was hilarious. Can't wait to post it on social media.",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 23,
      name: "allinpg",
      role: "Business Owner",
      company: "United States",
      content: "Great work. Exactly what i asked for... I am very pleased and highly recommend.",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 24,
      name: "natis100",
      role: "Creator",
      company: "United States",
      content: "Thank you <3 Amazing!!",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 25,
      name: "recouncut",
      role: "Content Creator",
      company: "United States",
      content: "it is an awesome video, didn't expect it to be this great..",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 26,
      name: "tylersba",
      role: "Creator",
      company: "United Kingdom",
      content: "Very Good communication very good product",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 27,
      name: "shukry4477",
      role: "Content Creator",
      company: "Jordan",
      content: "Really good",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 28,
      name: "farm4429",
      role: "Business Owner",
      company: "United States",
      content: "Extremely satisfied with your work quality",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 29,
      name: "lifelessonsg",
      role: "Creator",
      company: "Australia",
      content: "very quick and professional",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 30,
      name: "goddesshudson",
      role: "Content Creator",
      company: "United States",
      content: "Great job!",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 31,
      name: "dmazlum49",
      role: "Creator",
      company: "Austria",
      content: "Thanks👍👍👍❤️",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 32,
      name: "deena_2024",
      role: "Social Media Manager",
      company: "United States",
      content: "Adil did an excellent job with the reels! He really captured the style and energy I was looking for... I'm very happy with the results",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 33,
      name: "magicalnomad",
      role: "Content Creator",
      company: "United States",
      content: "Quick and responsive. Will be doing more work with Adil",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 34,
      name: "leecon123",
      role: "Business Owner",
      company: "Netherlands",
      content: "This is the second time I have worked with him and he's very professional... his work is fantastic",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 35,
      name: "gkeinemann",
      role: "Creator",
      company: "Germany",
      content: "Good job. Thanks",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 36,
      name: "davidoceans906",
      role: "Content Creator",
      company: "Spain",
      content: "Excellent work, 100% recommended. I will hire him again...",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 37,
      name: "jjdill",
      role: "Video Producer",
      company: "Trinidad and Tobago",
      content: "Exceptional work done and the attention to what was asked...",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 38,
      name: "belle_blumm",
      role: "Creator",
      company: "Portugal",
      content: "very good thanks",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 39,
      name: "sr132hw",
      role: "Social Media Manager",
      company: "United Kingdom",
      content: "I have been working with Adil for a while. He makes all my social media reels, very good quality work and very professional.",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 40,
      name: "iamnoon66",
      role: "Content Creator",
      company: "India",
      content: "He gave his best. I am going to hire him for a few more videos.",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 41,
      name: "theskimmie",
      role: "Creator",
      company: "United States",
      content: "Thanks for the videos.",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 42,
      name: "wellnixhealth",
      role: "Health Content Creator",
      company: "Poland",
      content: "good job! Fast",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 43,
      name: "abigalehaynes",
      role: "Content Producer",
      company: "United States",
      content: "Seller did a fantastic job. I will be working with him again. Thank you so much.",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 44,
      name: "matthew123_123",
      role: "Creator",
      company: "United Kingdom",
      content: "V good. Happy! Thanks",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 45,
      name: "chelseakate337",
      role: "Content Creator",
      company: "United States",
      content: "Excellent work!",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 46,
      name: "antebrzz",
      role: "Creator",
      company: "Croatia",
      content: "Good work.",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 47,
      name: "mikedk02",
      role: "Content Creator",
      company: "Puerto Rico",
      content: "Great work !",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 48,
      name: "teareliefco",
      role: "Business Owner",
      company: "United States",
      content: "The video quality was great 😊",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 49,
      name: "anderson4445",
      role: "Digital Marketer",
      company: "United States",
      content: "This seller is perhaps the best seller i ever seen on fiverr... great amount of value and been very eye to detail.",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 50,
      name: "dylanskanes",
      role: "Content Creator",
      company: "United States",
      content: "the finished product was amazing, thank you again...",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 51,
      name: "derreckg",
      role: "Creator",
      company: "United States",
      content: "Excellent work!!",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 52,
      name: "blessingsfair",
      role: "Digital Creator",
      company: "Thailand",
      content: "adil was a pleasure to work with... I would recommend him and will personally keep working with him. 10/10",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 53,
      name: "nikkynycole",
      role: "Content Creator",
      company: "United States",
      content: "Video looks good thank you will be ordering again real soon.",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 54,
      name: "devin_77",
      role: "Channel Owner",
      company: "United States",
      content: "he did an amazing job for me and with super fast delivery... you crushed it",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 55,
      name: "dan_kd",
      role: "Creator",
      company: "French Guiana",
      content: "tout bon à recommander le taf est beau",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 56,
      name: "topbenjamin1",
      role: "Content Creator",
      company: "United States",
      content: "Great job on A.I videos would definitely rehire and recommend!",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 57,
      name: "chriss1088",
      role: "Channel Owner",
      company: "United States",
      content: "like usual 10 out of 10",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 58,
      name: "goldaffiliate88",
      role: "Marketer",
      company: "Germany",
      content: "Very good Job, very creativity videos with good idea. Thank you so much.",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 59,
      name: "wuforever36",
      role: "Business Owner",
      company: "United States",
      content: "Great work was very professional.",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 60,
      name: "asnservicesllc",
      role: "Service Provider",
      company: "United States",
      content: "Very pleased with the work and professionalism.",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 61,
      name: "eveveyroj",
      role: "Content Creator",
      company: "United States",
      content: "Love his work, fast and quality",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 62,
      name: "deshaun_369",
      role: "Creator",
      company: "United States",
      content: "The seller did everything as told... Wowwww!!!",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 63,
      name: "dbmedia264",
      role: "Media Producer",
      company: "Puerto Rico",
      content: "worked good",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 64,
      name: "wolfgang919",
      role: "Business Owner",
      company: "United States",
      content: "Adil did a great job. highly recommend. will be hiring for more work soon.",
      rating: 5,
      response: "thanks I appreciate it"
    },
    {
      id: 65,
      name: "ctnorbaya",
      role: "YouTuber",
      company: "Malaysia",
      content: "Adil delivered a very good job. His last video has managed to reach more views than my typical video.",
      rating: 5,
      response: "Thank you so much"
    },
    {
      id: 66,
      name: "oliwer_nimoai",
      role: "Content Creator",
      company: "Sweden",
      content: "Very happy with the service - 5 star",
      rating: 5,
      response: "Thank you so much"
    }
  ],
  
  about: {
    title: "Turning Ideas into Scroll-Stopping Content",
    description: "Hi, I'm Adil — a professional AI Video Creator and Short-Form Video Editor with over 4 years of experience. I specialize in creating high-quality, viral-ready videos using the latest AI tools like Google Veo 3. My focus is on Instagram Reels, TikTok, YouTube Shorts, and faceless cash cow content that actually performs. With a perfect 5.0 rating across all gigs and fast 1-hour response time, I deliver stunning, engaging videos that help creators and brands grow their audience quickly.",
    profileImage: "/profile-photo.jpg",
    stats: [
      { label: "Years Experience", value: "4+" },
      { label: "Total Reviews", value: "192" },
      { label: "Average Rating", value: "5.0" },
      { label: "Response Time", value: "1hr" }
    ],
    languages: ["English", "Spanish", "German", "Arabic"],
    location: "Pakistan",
    hourlyRate: "$15/hour",
    fiverr: "Level 2 Seller"
  },
  
  contact: {
    email: "fiverr1845@gmail.com",
    whatsapp: "+923174708214",
    fiverr: "https://www.fiverr.com/adeel_expert01",
    facebook: "https://www.facebook.com/adeel.gaming.1",
    instagram: "https://www.instagram.com/arielleviofficiall/?hl=en",
    availability: "Available for projects - 1 hour response time"
  }
};